import { SlideshowSelectEvent } from '@theme/events';
import { prefersReducedMotion } from '@theme/utilities';
import { warmLazyVideo } from '@theme/lazy-video';

/**
 * Plays the active slide video and pauses the rest.
 * @param {ParentNode} root
 * @param {number} activeIndex
 */
function syncHeroBannerVideos(root, activeIndex) {
  const reduceMotion = prefersReducedMotion();

  root.querySelectorAll('slideshow-slide').forEach((slide, index) => {
    slide.querySelectorAll('video').forEach((video) => {
      if (!(video instanceof HTMLVideoElement)) return;

      if (index === activeIndex && !reduceMotion) {
        warmLazyVideo(video);
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  });
}

/**
 * Restarts the autoplay timer from the current slide.
 * @param {HTMLElement} slideshow
 */
function restartHeroAutoplay(slideshow) {
  if (typeof slideshow.suspend !== 'function' || typeof slideshow.play !== 'function') return;
  if (!slideshow.autoplay) return;

  slideshow.suspend();
  slideshow.play();
}

/**
 * Restarts the selected pagination progress bar to match autoplay.
 * @param {HTMLElement} slideshow
 */
function restartHeroProgress(slideshow) {
  const duration = slideshow.autoplayInterval;
  const fills = slideshow.querySelectorAll('.slideshow-controls__progress');
  const active = slideshow.querySelector(
    '.slideshow-controls__numbers button[aria-selected="true"] .slideshow-controls__progress'
  );

  fills.forEach((fill) => {
    if (!(fill instanceof HTMLElement)) return;
    fill.style.animation = 'none';
    fill.style.transform = 'scaleX(0)';
  });

  if (!(active instanceof HTMLElement) || !duration) return;

  void active.offsetWidth;
  active.style.animation = `hero-banner-progress ${duration}ms linear forwards`;
}

/**
 * @param {Element} banner
 */
function bindHeroBanner(banner) {
  const slideshow = banner.querySelector('slideshow-component');
  if (!slideshow) return;

  slideshow.addEventListener(SlideshowSelectEvent.eventName, (event) => {
    if (!(event instanceof SlideshowSelectEvent)) return;
    syncHeroBannerVideos(banner, event.detail.index);
    restartHeroProgress(slideshow);
    restartHeroAutoplay(slideshow);
  });

  syncHeroBannerVideos(banner, 0);
  restartHeroProgress(slideshow);
}

document.querySelectorAll('[data-hero-banner]').forEach(bindHeroBanner);
